/// <amd-module name="TFS/Admin/Views/OrganizationOverview/Components/DeleteOrganization/DeleteOrganizationDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { Link } from "VSSUI/Link";
import { IVssPageContext } from "VSS/Platform/Context";
import { TextField } from "VSSUI/TextField";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { ObservableValue } from "VSS/Core/Observable";
import { KeyCode } from "VSSUI/Util";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";

import AdminResources = require("TFS/Admin/Views/OrganizationOverview/Resources");
import { ContentSize } from "VSSUI/Callout";

export interface IDeleteOrganizationDialogProps {
    pageContext: IVssPageContext;
    organizationName: string;
    onCancel: () => void;
    onDeleteOrganization: () => void;
}

interface IDeleteOrganizationDialogState {
    isMatch: boolean;
}

export class DeleteOrganizationDialog extends React.Component<IDeleteOrganizationDialogProps, IDeleteOrganizationDialogState> {
    private organizationName = new ObservableValue<string>("");

    constructor(props: IDeleteOrganizationDialogProps) {
        super(props);
        this.state = {
            isMatch: false
        };
        this._onNameChanged = this._onNameChanged.bind(this);
    }

    public render(): JSX.Element {
        return (
            <Dialog
                onDismiss={() => {
                    this.props.onCancel();
                }}
                contentSize={ContentSize.Large}
                className="delete-organization-dialog"
                titleProps={{
                    text: AdminResources.DeleteOrganizationDialogTitle,
                    className: "fontWeightSemiBold"
                }}
                footerButtonProps={[
                    {
                        text: AdminResources.Cancel,
                        onClick: () => {
                            this.props.onCancel();
                        }
                    },
                    {
                        className: "delete-organization-button",
                        danger: true,
                        disabled: !this.state.isMatch,
                        onClick: () => this.props.onDeleteOrganization(),
                        text: AdminResources.DeleteOrganizationButton
                    }
                ]}
            >
                <div className="delete-organization-dialog-content flex-column">
                    <div className="delete-organization-first-paragraph">
                        <FormatComponent format={AdminResources.DeleteOrganizationFirstParagraph}>
                            <span className="delete-organization-name fontWeightSemiBold">{this.props.organizationName}</span>
                        </FormatComponent>
                    </div>
                    <div className="delete-organization-second-paragraph">
                        {AdminResources.DeleteOrganizationSecondParagraph}
                        <Link
                            className="learn-more-link"
                            href={AdminResources.DeleteOrganizationDialogLearnMoreLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {AdminResources.DeleteOrganizationDialogLearnMoreText}
                        </Link>
                    </div>
                    <div className="delete-organization-action-paragraph">
                        <FormatComponent format={AdminResources.DeleteOrganizationConfirmationText}>
                            <span className="delete-organization-name fontWeightSemiBold">{this.props.organizationName}</span>
                        </FormatComponent>
                    </div>
                    <TextField
                        className="delete-button-text-field"
                        placeholder={AdminResources.DeleteOrganizationPlaceholderText}
                        value={this.organizationName}
                        ariaLabel={AdminResources.DeleteOrganizationPlaceholderText}
                        onKeyDown={this._onKeyPress}
                        onChange={this._onNameChanged}
                    />
                    <div className="top-margin">
                        <FormatComponent format={AdminResources.AgreementStatement}>
                            <span className="fontWeightSemiBold">{AdminResources.BoldDelete}</span>
                            <Link href={AdminResources.TermsOfServiceLink} target="_blank" rel="noopener noreferrer">
                                {AdminResources.TermsOfService}
                            </Link>
                            <Link href={AdminResources.PrivacyStatementLink} target="_blank" rel="noopener noreferrer">
                                {AdminResources.PrivacyStatement}
                            </Link>
                        </FormatComponent>
                    </div>
                </div>
            </Dialog>
        );
    }

    private _onNameChanged = (event: any, value: string) => {
        this.organizationName.value = value;
        this._validateorganizationName(value);
    };

    //event.keycode returns zero so using which instead
    private _onKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.which === KeyCode.enter && this.state.isMatch) {
            this.props.onDeleteOrganization();
        }
    };

    private _validateorganizationName = (name: string): void => {
        if (localeIgnoreCaseComparer(name, this.props.organizationName) === 0) {
            this.setState({ isMatch: true });
        } else {
            this.setState({ isMatch: false });
        }
    };
}
